import { forwardRef, type InputHTMLAttributes } from 'react';
import styles from './FormField.module.css';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
}

const FormField = forwardRef<HTMLInputElement, Props>(
  ({ label, error, className = '', id, ...rest }, ref) => {
    const inputId = id ?? label.toLowerCase().replace(/\s+/g, '-');
    return (
      <div className={styles.field}>
        <label className={styles.label} htmlFor={inputId}>
          {label}
        </label>
        <input
          ref={ref}
          id={inputId}
          className={`${styles.input} ${error ? styles.error : ''} ${className}`.trim()}
          {...rest}
        />
        {error && <p className={styles.errorText}>{error}</p>}
      </div>
    );
  },
);

FormField.displayName = 'FormField';
export default FormField;
